<div class="border-end bg-white" id="sidebar-wrapper">
  <span onclick="openNav()" class="openbtnIAG"><i class="fa fa-bars fa-lg"></i></span>
  <div class="list-group list-group-flush">
    <div id="mySidenav" class="sidenav">
      <div class="nav-header">
        <a href="javascript:void(0)" class="closebtnIAG" onclick="closeNav()">
          <i class="fa fa-bars fa-lg"></i>
        </a>
      </div>
      <div id="sideMenu-header" class="sideMenu-header">
        <a href="/home">
          <img class="sideMenu-logo logo2" [src]="configService.getLogo('BA_LOGO_MOBILE')" />
        </a>
      </div>
      <div class="sidebar-nav">
        <ul class="parent">
          <span class="notSubmenu">
            <a href="/" class="liclass">
              <span class="nav-text"><i class="fa fa-home fa-smx"></i>NDC Hub</span>
            </a>
          </span>
        </ul>
      </div>
    </div>
  </div>
</div>
